import { ActionReducerMap } from '@ngrx/store';

import * as CartReducer from './cart/cart.reducer';
import * as ClaimReducer from './claims/claims.reducer';
import * as ConfigReducer from './config/config.reducer';
import * as HistoryReducer from './history/history.reducer';
import { State as PrismicState, reducer as prismicReducer } from './prismic/prismic.reducer';
import * as ProductReducer from './product/product.reducer';
import * as RemitReducer from './remit/remit.reducer';
import * as UserReducer from './user/user.reducer';
import * as VehicleReducer from './vehicle/vehicle.reducer';

export interface State {
  productState: ProductReducer.State;
  configState: ConfigReducer.State;
  cartState: CartReducer.State;
  userState: UserReducer.State;
  vehicleState: VehicleReducer.State;
  remitState: RemitReducer.State;
  historyState: HistoryReducer.State;
  claimState: ClaimReducer.State;
  prismicState: PrismicState;
}

export const reducers: ActionReducerMap<State> = {
  productState: ProductReducer.reducer,
  configState: ConfigReducer.reducer,
  cartState: CartReducer.reducer,
  userState: UserReducer.reducer,
  vehicleState: VehicleReducer.reducer,
  remitState: RemitReducer.reducer,
  historyState: HistoryReducer.reducer,
  claimState: ClaimReducer.reducer,
  prismicState: prismicReducer,
};
